import React from "react";

import { RootStore } from "./root";

export const storeContext = React.createContext<RootStore | null>(null);
export const StoreProvider = storeContext.Provider;
export const useStore = (): RootStore =>
  React.useContext(storeContext) as RootStore;
